import { render, staticRenderFns } from "./ClaimsLookupResults.vue?vue&type=template&id=a734a544"
import script from "./ClaimsLookupResults.vue?vue&type=script&lang=ts"
export * from "./ClaimsLookupResults.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports